import { render, staticRenderFns } from "./nice-spoiler.vue?vue&type=template&id=6f87e15d&scoped=true"
import script from "./nice-spoiler.vue?vue&type=script&lang=js"
export * from "./nice-spoiler.vue?vue&type=script&lang=js"
import style0 from "./nice-spoiler.vue?vue&type=style&index=0&id=6f87e15d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87e15d",
  null
  
)

export default component.exports